import { useTranslation } from 'react-i18next';
import { date, object, string, number, array } from 'yup';

import { PolicyTypes } from '@models/policyType';

import { FormValues } from './type';

export const useFormValues = () => {
  const values: FormValues = {
    insurerId: '',
    benefitTemplateIds: [],
    companyId: '',
    insuranceType: '',
    policyType: '',
    effectiveDate: '',
    expirationDate: '',
    adminFeeAmount: '',
    note: '',
    descriptionHtml: '',
  };
  return values;
};

export const useFormSchema = () => {
  const { t } = useTranslation();
  return object({
    insurerId: number().required(t('validation:required')),
    benefitTemplateIds: array().of(number()).required(t('validation:required')),
    companyId: number()
      .when('policyType', {
        is: (policyType: PolicyTypes) => policyType === PolicyTypes.Commercial,
        then: (schema) => schema.required(t('validation:required')),
        otherwise: (schema) => schema.optional(),
      }),
    insuranceType: string().required(t('validation:required')),
    policyType: string().required(t('validation:required')),
    effectiveDate: date().required(t('validation:required')),
    expirationDate: date().required(t('validation:required')),
    adminFeeAmount: number().required(t('validation:required')),
    note: string().required(t('validation:required')),
    descriptionHtml: string().required(t('validation:required')),
  });
};
